import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';

/**
 * Custom hook to validate MFA user session and redirect if missing
 *
 * This hook checks if the user context is available (indicating a valid session).
 * If the user is missing (likely due to page refresh or expired session),
 * it redirects to the login page with an MFA session expired error.
 *
 * @param user - The user object from AuthContext
 */
export const useMfaSessionValidation = (user: unknown) => {
  const navigate = useNavigate();
  const hasMountedRef = useRef(false);

  useEffect(() => {
    // Skip validation on initial mount to allow user state to propagate
    if (!hasMountedRef.current) {
      hasMountedRef.current = true;
      return;
    }

    if (!user) {
      // User context is missing (likely due to page refresh), redirect to login
      navigate('/login?error=mfa_session_expired');
    }
  }, [user, navigate]);
};
